// Mobile Filters Controller
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "panel", "backdrop"]

  connect() {
    // Bind escape key listener
    this.escapeHandler = this.handleEscape.bind(this)
    
    // Prevent body scroll when modal is open
    this.originalOverflow = document.body.style.overflow
  }

  disconnect() {
    document.removeEventListener('keydown', this.escapeHandler)
    
    // Restore original body overflow
    document.body.style.overflow = this.originalOverflow
  }

  open(event) {
    event.preventDefault()
    
    // Show modal
    this.modalTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
    
    // Add escape key listener
    document.addEventListener('keydown', this.escapeHandler)
    
    // Animate panel in
    requestAnimationFrame(() => {
      this.panelTarget.classList.remove('translate-x-full')
      this.panelTarget.classList.add('translate-x-0')
    })
    
    // Set focus to first input
    const firstInput = this.panelTarget.querySelector('input, select, button')
    if (firstInput) {
      firstInput.focus()
    }
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }
    
    // Animate panel out
    this.panelTarget.classList.remove('translate-x-0')
    this.panelTarget.classList.add('translate-x-full')
    
    // Hide modal after animation
    setTimeout(() => {
      this.modalTarget.classList.add('hidden')
      document.body.style.overflow = this.originalOverflow
    }, 300)
    
    // Remove escape key listener
    document.removeEventListener('keydown', this.escapeHandler)
  }

  applyAndClose(event) {
    event.preventDefault()
    
    // Trigger the filters submission
    const filtersController = this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-controller*="filters"]'),
      'filters'
    )
    
    if (filtersController) {
      filtersController.submitFilters()
    }
    
    // Close the modal
    this.close()
  }

  handleEscape(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }

  // Handle backdrop clicks
  backdropClick(event) {
    if (event.target === this.backdropTarget) {
      this.close()
    }
  }

  // Prevent panel clicks from closing modal
  panelClick(event) {
    event.stopPropagation()
  }
}
